export const TEMPLATE_NAMES = {
  SIM: 'sim',
  MOBILE_PLAN: 'mobilePlan'
}
